import { useObservableValue } from "@iventis/utilities";
import React, { useContext } from "react";
import { Group } from "@iventis/types";
import { HeaderRenderer } from "../interactive-grid.types";
import { IGridContext } from "../state/interactive-grid-context";

export const IGridHeaderHorizontal: React.FC<{
    groups: Group[];
    height: number;
    groupWidth: number;
    originWidth: number;
    renderColumnHeader: HeaderRenderer;
}> = ({ height, groups, groupWidth, originWidth, renderColumnHeader }) => {
    const ctx = useContext(IGridContext);

    const xTranslate = useObservableValue(ctx.xTranslation);

    return (
        <div
            style={{
                position: "absolute",
                height: `${height}px`,
                background: "white",
                transform: `translateX(${xTranslate}px)`,
                marginLeft: originWidth,
                whiteSpace: "nowrap",
            }}
        >
            {groups?.map((group) => (
                <div key={group.groupId} style={{ display: "inline-block", height: `${height}px`, width: `${groupWidth}px` }}>
                    {renderColumnHeader(group)}
                </div>
            ))}
        </div>
    );
};
